import { AutogenModelCreditOverride, AutogenRowCreditOverride } from "./autogen/AutogenModelCreditOverride";

export class ModelCreditOverride extends AutogenModelCreditOverride<RowCreditOverride> {
	constructor() {
		super(RowCreditOverride);
	}
}

export class RowCreditOverride extends AutogenRowCreditOverride {
}